import styled from 'styled-components';

export const StyledGoBackToMainMenuButton = styled.button`
  appearance: none;
  border: 0;
  margin: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  transform: translateX(-0.625em);
`;
